import {i18n} from '@/plugins/i18n';
import {transmitDescription, transmitDescriptionStr} from '@/constants/transmitDescription';
import {transmitType, transmitTypeStr} from "@/constants/transmitType";
import DescriptionColumn from "./Description.vue";

const descriptionTemplate = (row, index, datatable) => {
    let template = new DescriptionColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}
export default [
    {
        field: 'format_balance',
        title: i18n.t('label.balance'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'formant_amount',
        title: i18n.t('label.amount'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'EndToEnd',
        title: i18n.t('label.reference_id'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'type',
        title: i18n.t('label.type'),
        sortable: false,
        textAlign: 'center',
        template: (row, index, datatable) => {
            if (row.type === 'DEBIT') {
                return "<div class='badge badge-danger'>برداشت</div>"
            }

            return "<div class='badge badge-success'>واریز</div>"

        },
    },
    {
        field: 'payment_date',
        title: i18n.t('label.date'),
        sortable: true,
        textAlign: 'center',

    },
    {
        field: 'action',
        width: 80,
        title: i18n.t('reports.actions'),
        template: (row, index, datatable) => {
            return descriptionTemplate(row, index, datatable)
        },
        sortable: false,
        textAlign: 'center',
    },
];